var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M25 1.67A23.4 23.4 0 0 0 1.67 25 23.4 23.4 0 0 0 25 48.33 23.4 23.4 0 0 0 48.33 25 23.4 23.4 0 0 0 25 1.67z", strokeWidth: "1.8", fillRule: "nonzero" }),
      React.createElement("path", { d: "M33.8 35.8l-12.13-7.47v-14h3.5v12.14l10.5 6.3z" })
    )
  );
});